import { render } from "./ChatSelectBox.vue?vue&type=template&id=c15c314a"
import script from "./ChatSelectBox.vue?vue&type=script&lang=js"
export * from "./ChatSelectBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__